/**
 * Centralized feature flags based on environment variables.
 *
 * All flags follow the naming convention: PUBLIC_FEATURE_<NAME>
 * A flag is enabled when the env var is set to a truthy value: "true", "1", "yes", "on" (case-insensitive).
 * If the env var is missing or set to anything else, the flag is disabled.
 */

function isTruthy(value: string | undefined): boolean {
  if (!value) return false;
  return ['true', '1', 'yes', 'on'].includes(value.trim().toLowerCase());
}

export const featureFlags = {
  shoppingCart: isTruthy(import.meta.env.PUBLIC_FEATURE_SHOPPING_CART),
  composable: isTruthy(import.meta.env.PUBLIC_FEATURE_COMPOSABLE) || isTruthy(import.meta.env.PUBLIC_FEATURE_FORGE),
  distribution: isTruthy(import.meta.env.PUBLIC_FEATURE_DISTRIBUTION),
} as const;
